import { createRouteRef } from '@backstage/frontend-plugin-api';

// The Help hub ("/help") and one ref per concept page. All param-free.
export const docsHubRouteRef = createRouteRef();
export const docHomeRouteRef = createRouteRef();
export const docApprovalsRouteRef = createRouteRef();
export const docWorkflowsRouteRef = createRouteRef();
export const docCatalogRouteRef = createRouteRef();
export const docIntegrationsRouteRef = createRouteRef();
export const docAdminDashboardRouteRef = createRouteRef();
export const docOthersRouteRef = createRouteRef();
export const docRefreshRouteRef = createRouteRef();
export const docMergeLordRouteRef = createRouteRef();
export const docQuicklinksRouteRef = createRouteRef();
export const docFeedbackRouteRef = createRouteRef();
export const docDeploymentsRouteRef = createRouteRef();
export const docKafkaQueryRouteRef = createRouteRef();

// Workflow detail page — reads `:slug` from the URL.
export const docWorkflowDetailRouteRef = createRouteRef({ params: ['slug'] });

// Approval kind detail page — reads `:kindId` from the URL.
export const docApprovalKindDetailRouteRef = createRouteRef({ params: ['kindId'] });
